import React from 'react'
import Wrapper from '../../components/layout/Wrapper'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import imgCallCenter from '../../images/asset-5.svg'
import imgEmail from '../../images/landing-contact-callcenter.svg'

const Container = styled(Wrapper)`
`

const ItemsGrid = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 40px;

  & > div {
    flex: 1 0 30%;
    margin-bottom: 20px;
    display: flex;
  }

  ${breakpoint('tablet')`
    flex-flow: row wrap;
    justify-content: space-between;
  `}
`

const ItemContainer = styled.div`
  display: flex;

  h4 {
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 12px;
    margin-right: 50px;
  }

  & > div {
    flex: 1 0;
  }

  & > div:first-of-type {
    flex: 0 0 60px;

    ${breakpoint('tablet')`
      margin-right: 20px;
      flex: 0 0 80px;
    `}
  }
`

const Item = ({ title, image, children }) => {
  return (
    <ItemContainer>
      <div>
        <img src={image} alt={title} />
      </div>
      <div>
        <h4>{title}</h4>
        <p>{children}</p>
      </div>
    </ItemContainer>
  )
}

export default ({ footer, countryAbr }) => {

  return (
    <div>
      <Container>
        <ItemsGrid>
          <Item title="Chatbot" image={imgCallCenter}>
                Consultas sobre la Chuzo Week <a href="https://agentevirtual.baccredomatic.com:40457/violeta/PrendarioCRI">click aquí</a>
          </Item>

          <Item title="Email" image={imgEmail}>
            Consultas sobre la Chuzo week <a href="mailto:creditovehiculos@bacsanjose.com">creditovehiculos@bacsanjose.com</a>
          </Item>
        </ItemsGrid>
      </Container>
    </div>
  )
}
